export default __webpack_public_path__ + "static/media/article2.e4dfd204.png";